<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center h-20 pt-6 px-8" *ngIf="!logo">
        <img
          class="w-24"
          src="assets/images/logo/logo-text-on-dark.svg"
          alt="Logo image" />
      </div>
      <div class="flex items-center h-20 pt-6 px-8" *ngIf="logo">
        <img class="w-24" [src]="logo" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 sm:h-15 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card text-white dark:bg-transparent print:hidden bg-primary-800"
    [ngClass]="{ 'bg-original': color }">
    <!-- [ngClass]="color != null ? color : '' " -->
    <ng-container *ngIf="!isScreenSmall">
      <!-- Logo -->
      <div class="flex items-center mx-2 lg:mr-2">
        <div class="hidden lg:flex" *ngIf="!logo">
          <img
            class="dark:hidden w-40"
            src="assets/images/logo/logo-text-on-dark.svg" />
          <img
            class="hidden dark:flex w-40"
            src="assets/images/logo/logo-text-on-dark.svg" />
        </div>
        <div class="hidden lg:flex" *ngIf="logo">
          <img class="dark:hidden w-40" [src]="logo" />
          <img class="hidden dark:flex w-40" [src]="logo" />
        </div>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 557.45 152.5"><defs><style>.cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#e6e7e8;}.cls-5{fill:#f1f2f2;}</style><clipPath id="clip-path" transform="translate(0 0.99)"><path class="cls-1" d="M45.47.85,3.18,25.27A6.34,6.34,0,0,0,0,30.78v48.5A6.36,6.36,0,0,0,3.2,84.8L45.39,109a6.36,6.36,0,0,0,6.32,0L93.9,84.8a6.36,6.36,0,0,0,3.2-5.52V30.77a6.35,6.35,0,0,0-3.17-5.5L51.84.86A6.36,6.36,0,0,0,45.47.85Z"/></clipPath></defs><title>ecommifyAsset 1</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-2" d="M146.11,56.56H119.27c1,3.69,4.39,6.28,9.65,6.28a33.57,33.57,0,0,0,11.38-2.36l3.45,10s-5.49,3.69-15.14,3.69c-15.7,0-22.52-9.42-22.52-20.72C106.09,42,113,32.7,126.8,32.7c12.4,0,19.46,7.69,19.46,20.72C146.26,54.28,146.19,55.54,146.11,56.56Zm-13-7.53a6.54,6.54,0,0,0-6.9-6.28c-4,0-6.91,3.61-6.91,6.28Z" transform="translate(0 0.99)"/><path class="cls-2" d="M187.7,69.35c-3.61,3.45-9.73,4.79-14.76,4.79-13.65,0-21.65-9.26-21.65-20.72s8.16-20.72,21.65-20.72c5,0,11,1.34,14.76,4.79l-4.56,10.12A14.45,14.45,0,0,0,173.73,44a9.43,9.43,0,1,0,0,18.84,14.81,14.81,0,0,0,9.41-3.54Z" transform="translate(0 0.99)"/><path class="cls-2" d="M234.15,53.42c0,11.46-8.63,20.72-21.34,20.72-13.26,0-21.35-9.26-21.35-20.72s7.93-20.72,21.35-20.72C225.36,32.7,234.15,42,234.15,53.42Zm-12.55,0c0-5.18-3.93-9.42-8.79-9.42S204,48.24,204,53.42s3.92,9.42,8.79,9.42S221.6,58.6,221.6,53.42Z" transform="translate(0 0.99)"/><path class="cls-2" d="M300.7,50.28v22.6H288.14V51.53c0-6.27-2.28-7.53-5-7.53s-6.28,1.73-6.28,8.79V72.88H264.28V51.53c0-6.27-2.27-7.53-5-7.53-2.59,0-6.27,1.73-6.27,8.79V72.88H240.43V34H253v3.76c2.66-3.13,5.49-5,10-5a12.4,12.4,0,0,1,10.44,5.1c3.37-3.84,8.31-5.1,12.16-5.1C293.56,32.7,300.7,38.51,300.7,50.28Z" transform="translate(0 0.99)"/><path class="cls-2" d="M369.12,50.28v22.6H356.57V51.53c0-6.27-2.28-7.53-5-7.53s-6.28,1.73-6.28,8.79V72.88H332.71V51.53c0-6.27-2.27-7.53-5-7.53-2.59,0-6.28,1.73-6.28,8.79V72.88H308.86V34h12.55v3.76c2.67-3.13,5.5-5,10-5a12.38,12.38,0,0,1,10.43,5.1,16.24,16.24,0,0,1,12.17-5.1C362,32.7,369.12,38.51,369.12,50.28Z" transform="translate(0 0.99)"/><path class="cls-2" d="M376,21.4a7.53,7.53,0,1,1,7.53,7.54A7.53,7.53,0,0,1,376,21.4ZM377.28,34h12.56V72.88H377.28Z" transform="translate(0 0.99)"/><path class="cls-2" d="M401.77,34c.08-8.79,1.57-17.58,12.55-17.58a25,25,0,0,1,8.79,1.26v10c-8.79-1.81-8.79,2-8.79,6.28h8.79v11.3h-8.79V72.88H401.77V45.26h-5V34Z" transform="translate(0 0.99)"/><path class="cls-2" d="M469.57,34,445.71,93H431.9L442,70.05,426.88,34h13.81l7.53,21.34L455.75,34Z" transform="translate(0 0.99)"/><path class="cls-2" d="M473.33,67.23a6.91,6.91,0,1,1,6.91,6.91A6.87,6.87,0,0,1,473.33,67.23Z" transform="translate(0 0.99)"/><path class="cls-2" d="M494.68,21.4a7.53,7.53,0,1,1,7.53,7.54A7.53,7.53,0,0,1,494.68,21.4ZM495.93,34h12.56V72.88H495.93Z" transform="translate(0 0.99)"/><path class="cls-2" d="M557.45,53.42c0,11.46-8.63,20.72-21.34,20.72-13.26,0-21.34-9.26-21.34-20.72s7.92-20.72,21.34-20.72C548.67,32.7,557.45,42,557.45,53.42Zm-12.55,0c0-5.18-3.93-9.42-8.79-9.42s-8.79,4.24-8.79,9.42,3.92,9.42,8.79,9.42S544.9,58.6,544.9,53.42Z" transform="translate(0 0.99)"/><g class="cls-3"><polygon class="cls-4" points="18.26 38.56 18.26 38.56 0 28.09 0 83.96 48.55 111.78 48.55 90.97 18.25 73.5 18.26 38.56"/><path class="cls-2" d="M65.33,43.56,50.87,35.3a4.6,4.6,0,0,0-4.62,0l-13.45,8A4.6,4.6,0,0,0,31.17,45l17.38,10,16.78-9.62A1,1,0,0,0,65.33,43.56Z" transform="translate(0 0.99)"/><path class="cls-5" d="M78.91,51.41,48.55,69v6.16a4.67,4.67,0,0,0,2.29-.61l15.91-9.15,12.16,7L48.55,90h0v20.81L97.1,83V27.1L78.91,37.53Z" transform="translate(0 0.99)"/><path class="cls-4" d="M48.55,54.93,31.17,45a4.57,4.57,0,0,0-.61,2.25L30.4,62.65a4.6,4.6,0,0,0,2.29,4l13.57,7.85a4.58,4.58,0,0,0,2.29.62V54.93Z" transform="translate(0 0.99)"/><polygon class="cls-2" points="78.91 38.51 97.1 28.09 48.66 0 0 28.09 18.26 38.56 48.55 20.82 78.91 38.51"/><path class="cls-2" d="M392.15,151.51a.91.91,0,0,0,0-1.82.91.91,0,0,0,0,1.82Z" transform="translate(0 0.99)"/><path class="cls-2" d="M392.15,151.51a.91.91,0,0,0,0-1.82.91.91,0,0,0,0,1.82Z" transform="translate(0 0.99)"/></g></g></g></svg> -->
        <!-- <img class="flex lg:hidden w-8" src="assets/images/logo/logo.svg" /> -->
      </div>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        class="mr-2"
        [name]="'mainNavigation'"
        [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
    </ng-container>
    <!-- Navigation toggle button -->
    <ng-container *ngIf="isScreenSmall">
      <button
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
        class="text-white">
        <mat-icon
          [svgIcon]="'heroicons_outline:menu'"
          class="text-on-primary"></mat-icon>
      </button>
    </ng-container>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!-- <languages></languages> -->
      <div *ngIf="showSettings()" routerLink="settings">
        <button mat-icon-button>
          <mat-icon
            [ngStyle]="{ color: 'white' }"
            [svgIcon]="'heroicons_outline:cog'"
            color=""></mat-icon>
        </button>
      </div>
      <!-- <div routerLink="settings">
        <button mat-icon-button>
          <mat-icon
            [ngStyle]="{ color: 'white' }"
            [svgIcon]="'heroicons_outline:inbox'"
            color=""></mat-icon>
        </button>
      </div> -->
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <!-- <search [appearance]="'bar'"></search> -->
      <!-- <shortcuts></shortcuts> -->
      <messages></messages>
      <!-- <notifications></notifications> -->
      <!-- <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
            </button> -->
      <!-- <user></user> -->
      <!-- <div *ngIf="showSettings()" routerLink="settings">
                <button mat-icon-button>
                    <mat-icon [ngStyle]="{ color: 'white' }" [svgIcon]="'heroicons_outline:cog'" color=""></mat-icon>
                </button>
            </div> -->
      <ng-container fuseVerticalNavigationFooter>
        <!-- User -->
        <user></user>
        <div
          class="flex items-center w-full px-0 py-8 border-t hidden sm:block">
          <div class="flex flex-col w-[160px] ml-1 overflow-hidden">
            <div
              *ngIf="showCompany()"
              class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current text-sm">
              {{ companyName }}
            </div>
            <div
              *ngIf="showSwitchCompany()"
              class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current text-sm">
              <mat-select
                [formControl]="companyControl"
                class="companyList"
                (selectionChange)="selectedCompany($event)">
                <mat-option disabled *ngIf="showFilter">
                  <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:search'"></mat-icon>
                  <input
                    class="min-w-0 ml-2 py-1 border-0"
                    type="text"
                    matInput
                    [formControl]="filterText"
                    placeholder="Search Company" />
                </mat-option>
                <mat-divider></mat-divider>

                <ng-container *ngIf="filteredOptions | async as company">
                  <mat-option disabled *ngIf="company.length === 0"
                    >No Companies Found</mat-option
                  >
                  <mat-option
                    *ngFor="let opt of companies; trackBy: trackByFn"
                    [value]="opt.company_id"
                    [ngStyle]="getOptionStyle(opt, company)"
                    >{{ opt.company_name }}</mat-option
                  >
                </ng-container>
              </mat-select>
            </div>
            <div
              class="w-full whitespace-nowrap text-xs text-ellipsis overflow-hidden leading-normal text-current opacity-50">
              {{ user?.name }}
            </div>

            <!-- <div
                            class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50">
                            {{ user.email }}
                        </div> -->
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto w-full">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer
    <div
        class="relative flex flex-0 items-center w-full h-14 sm:h-10 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary text-md">ecommify.io &copy; {{ currentYear }} | a Wolfgroup
            product</span>
    </div>-->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
